export default "__VITE_ASSET__bjsKfGGf__"